/* KICX custom pages — shared JS (reveal, bars, flavour switcher, add-to-cart). */
(function () {
  const roots = document.querySelectorAll('.kicx-page');
  if (!roots.length) return;

  // Scroll reveal
  const io = new IntersectionObserver(entries => {
    entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('visible'); io.unobserve(e.target); } });
  }, { threshold: 0.12 });
  document.querySelectorAll('.kicx-page .reveal').forEach(el => io.observe(el));

  // Failsafe: reveal anything already in (or near) the viewport — covers anchor-link arrivals and fast jumps
  const kxRevealInView = () => {
    document.querySelectorAll('.kicx-page .reveal:not(.visible)').forEach(el => {
      const r = el.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('visible');
    });
  };
  window.addEventListener('load', () => setTimeout(kxRevealInView, 400));
  window.addEventListener('hashchange', () => setTimeout(kxRevealInView, 700));
  if ('onscrollend' in window) window.addEventListener('scrollend', kxRevealInView);

  // Animated width bars (reviews summary)
  const barIO = new IntersectionObserver(es => {
    es.forEach(e => { if (e.isIntersecting) { e.target.style.width = e.target.dataset.w; barIO.unobserve(e.target); } });
  }, { threshold: 0.5 });
  document.querySelectorAll('.kicx-page [data-w]').forEach(b => barIO.observe(b));

  // Flavour switcher — swaps image and points the card's Add button at the right variant
  document.querySelectorAll('.kicx-page .flav[data-variant]').forEach(btn => {
    btn.addEventListener('click', () => {
      const card = btn.closest('.pcard');
      btn.parentElement.querySelectorAll('.flav').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      const imgId = btn.dataset.imgTarget;
      const img = imgId ? document.getElementById(imgId) : null;
      if (img && btn.dataset.img) {
        img.style.opacity = 0;
        setTimeout(() => { img.src = btn.dataset.img; img.style.transition = 'opacity .4s'; img.style.opacity = 1; }, 200);
      }
      if (card) {
        const add = card.querySelector('.add-btn[data-add]');
        if (add) add.dataset.add = btn.dataset.variant;
      }
      if (btn.dataset.price) {
        const priceEl = card ? card.querySelector('[data-gift-price]') : null;
        if (priceEl) priceEl.textContent = btn.dataset.price;
      }
    });
  });

  // Add to cart — real Shopify cart + theme drawer. Single listener, in-flight guard.
  document.querySelectorAll('.kicx-page [data-add]').forEach(btn => {
    btn.addEventListener('click', async () => {
      const id = parseInt(btn.dataset.add, 10);
      if (!id || btn.disabled) return;
      const original = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adding…';
      try {
        const res = await fetch((window.KROWN && KROWN.settings && KROWN.settings.routes && KROWN.settings.routes.cart_add_url) || '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
          body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
        });
        if (!res.ok) throw new Error('add failed');
        btn.classList.add('kx-added');
        btn.innerHTML = '<svg class="kx-tick" viewBox="0 0 24 24" aria-hidden="true"><path d="M4 12.5l5 5L20 6.8"/></svg>Added';
        if (typeof window.refreshCart === 'function') { window.refreshCart(true); } else { window.location.href = '/cart'; }
      } catch (err) {
        btn.textContent = 'Try again';
        console.error('KICX add-to-cart:', err);
      } finally {
        setTimeout(() => { btn.textContent = original; btn.classList.remove('kx-added'); btn.disabled = false; }, 2000);
      }
    });
  });
})();
